import React, { useReducer, useState } from 'react';
import './App.css';

const formReducer = (state, event) => {
  if (event.reset) {
    return {
      timeZone: '',
      fName: '',
      lName: '',
      email: '',
      company: '',
      jobTitle: '',
      'consent': false,
    }
  }
  return {
    ...state,
    [event.name]: event.value
  }
}

function App() {
  const [formData, setFormData] = useReducer(formReducer, {});
  const [submitting, setSubmitting] = useState(false);

  // Because this a demo, 'handleSubmit' will prevent form from submitting and trigger an alert
  const handleSubmit = event => {
    event.preventDefault();
    setSubmitting(true);
  }

  const handleChange = event => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked :  event.target.value,
    })
  }

  return (
    <div className="wrapper">
      {submitting &&
        <div className="container-fluid results-wrapper">
          <div className="p-4 border rounded-3 bg-light results">
            <div className="col-xl p-4">
              <h3 className="pb-3">This form would be passing these fields if it were live:</h3>
              <ul>
                {Object.entries(formData).map(([name, value]) => (
                  <li key={name}><strong>{name}</strong>: {value.toString()}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      }
      <form className="p-4 border rounded-3 bg-light" onSubmit={handleSubmit}>
        <h2 className="mb-4">Download the <span className="nowrap">free guide</span></h2>
        <fieldset className="form-floating mb-3" disabled={submitting}>
          <input className="form-control" id="floatingInput" type="text" name="fName" placeholder="John" required onChange={handleChange} value={formData.fName || ''} />
          <label htmlFor="floatingInput">First Name</label>
        </fieldset>

        <fieldset className="form-floating mb-3" disabled={submitting}>
          <input className="form-control" type="text" name="lName" placeholder="Doe" required onChange={handleChange} value={formData.lName || ''} />
          <label htmlFor="floatingInput">Last Name</label>
        </fieldset>

        <fieldset className="form-floating mb-3" disabled={submitting}>
          <input className="form-control" type="email" name="email" placeholder="john.doe@email.com" required onChange={handleChange} value={formData.email || ''} />
          <label htmlFor="floatingInput">Email</label>
        </fieldset>

        <fieldset className="form-floating mb-3" disabled={submitting}>
          <input className="form-control" type="text" name="jobTitle" placeholder="Regional Manager" required onChange={handleChange} value={formData.jobTitle || ''} />
          <label htmlFor="floatingInput">Job Title</label>
        </fieldset>

        <fieldset className="form-floating mb-3" disabled={submitting}>
          <input className="form-control" type="text" name="company" placeholder="Medtech, Inc." required onChange={handleChange} value={formData.company || ''} />
          <label htmlFor="floatingInput">Company</label>
        </fieldset>

        <fieldset className="form-floating" disabled={submitting}>
          <select className="form-select" id="floatingSelect" aria-label="Floating label Default select example" name="timeZone" onChange={handleChange} value={formData.timeZone || ''}>
            <option value="">Select time zone</option>
            <option value="eastern">Eastern</option>
            <option value="central">Central</option>
            <option value="mountain">Mountain</option>
            <option value="western">Western</option>
            <option value="hawaii">Hawaii</option>
          </select>
          <label htmlFor="floatingSelect">Time Zone</label>
        </fieldset>

        <div className="form-check my-3">
          <fieldset disabled={submitting}>
            <input className="form-check-input" id="flexCheckDefault" type="checkbox" name="consent" required onChange={handleChange} value={formData.consent || ''} />
            <label className="form-check-label">I agree to submit my information<br></br>(this is a demo and no information is being sent)</label>
          </fieldset>
        </div>
        <div className="d-grid gap-2 col-6 mx-auto">
          <button className="btn btn-primary btn-lg" type="submit" disabled={submitting}>Submit</button>
        </div>
      </form>
    </div>
  )
}

export default App;